<div class="row">
  <div class="col-md-9">
    <h1 mat-dialog-title>Create Prepaid Providers</h1>
  </div>
  <div class="col-md-3">
    <span class="pull-right f-13" (click)="closeDialog()"> X </span>
  </div>
</div>
<div mat-dialog-content>
  <form [formGroup]="prePaidForm" role="form">
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">ProviderName</label>
        <input
          type="text"
          class="form-control"
          formControlName="providerName"
        />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label"> EnergyRate</label>
        <input type="text" class="form-control" formControlName="energyRate" />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">UtilityName</label>
        <input type="text" class="form-control" formControlName="utilityName" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">Daily Charge</label>
        <input
          type="text"
          class="form-control"
          formControlName="tDSPRatePerMonth"
        />
      </div>
    </div>
    <div class="row mt-3">
    <div class="col-md-6">
      <label for="userId" class="control-label">TDU Charges per Month</label>
      <input
        type="text"
        class="form-control"
        formControlName="tDU_Charges_Month"
      />
    </div>
 
 
    <div class="col-md-6">
      <label for="userId" class="control-label">TDU Charges per kWh</label>
      <input
        type="text"
        class="form-control"
        formControlName="tDU_Charges_Kwh"
      />
    </div>
  </div>
    <div class="row mt-3">
      <!-- <div class="col-md-6">
        <label for="userId" class="control-label">TDSPRatePerkWh</label>
        <input
          type="text"
          class="form-control"
          formControlName="TDSPRatePerkWh"
        />
      </div> -->
      <div class="col-md-6">
        <label for="userId" class="control-label">link</label>
        <input
          type="text"
          class="form-control"
          formControlName="link"
        />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">500kWh</label>
        <input
          type="text"
          class="form-control"
          formControlName="FivehundredkWh"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-6">
        <label for="userId" class="control-label">1000kWh</label>
        <input type="text" class="form-control" formControlName="ThousandkWh" />
      </div>
      <div class="col-md-6">
        <label for="userId" class="control-label">2000kWh</label>
        <input
          type="text"
          class="form-control"
          formControlName="TwoThousandkWh"
        />
      </div>
    </div>

    <div class="pull-right mt-2">
      <button
        class="mr-2 mt-0 btn sectbtn brdrRadius"
        (click)="postDataOfNewEnergyProvider()"
      >
        Submit
      </button>
      <button mat-raised-button (click)="closeDialog()">Cancel</button>
    </div>
  </form>
  <!-- <input matInput [(ngModel)]="data.animal"> -->
</div>
<!-- <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">No Thanks</button>
    <button class="btn btn-primary" (click)="postDataOfNewEnergyProvider()">
      Submit
    </button>
  </div> -->
